module.exports = __webpack_public_path__ + "img/grif.daaa21df.png";